import React, { useContext } from "react";
import { Button, Col, Container, Input, Label, Row } from "reactstrap";
import { THEME_UPDATE_MESSAGE, ThemeNo } from "../../../../constant";
import LatestNewsContext from "../../../context/LatestNewsContext/LatestNewsContext";
import { TostMessage } from "../../../utils";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import { LatestNewStyleOneReset } from "./LatestNewaStyleFunction";
import { putUpdateLatestNews } from "../apis/LatestNewsApi/LatestNewsApi";
import LatestNewThemeOne from "./LatestNewThemeOne";
import LatestNewsTheme1 from "../ScreenShorts/LatestNews/LatestNewsTheme1.png";
import ThemeImageShow from "../../../common/ThemeImageShow";

const SettingImageParentPopup = (props) => {
  const { setLoaderShow } = useContext(LoaderContext);
  const {
    isEdit,
    setSettingFormData,
    setbackImageToggle,
    setBoxSection,
    setIsBackgroundColor,
    imgShow,
    setImgShow,
    theme,
    setTheme,
    id,
  } = useContext(LatestNewsContext);
  const { imageUpload, handleSubmitSetting, handleChangeSettings } = props;

  const handleTheme = async (e) => {
    setLoaderShow(true);
    const { value } = e.target;
    setTheme(value);
    try {
      let formData = {
        theme: value,
        latestNewsId: id,
      };
      const { data } = await putUpdateLatestNews(formData);
      if (data.status === 200) {
        await handleChangeSettings(id, true);
        TostMessage({
          message: { message: THEME_UPDATE_MESSAGE },
          type: "success",
        });
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    } finally {
      setLoaderShow(false);
    }
  };

  const handleReset = () => {
    let setStyle;
    if (theme === ThemeNo.ThemeOne) {
      setStyle = LatestNewStyleOneReset;
    } else {
      setStyle = LatestNewStyleOneReset;
    }
    setSettingFormData({ ...setStyle });
    setbackImageToggle(false);
    setBoxSection(false);
    setIsBackgroundColor(true);
  };
  const handleClose = () => {
    setImgShow(false);
  };
  const themeImg = {
    1: LatestNewsTheme1,
  };

  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center position-relative">
              <div
                className="d-flex justify-content-between position-sticky"
                style={{ top: "87px", background: "white", zIndex: 999 }}
              >
                <h6>{isEdit ? "Edit" : "Add New"}</h6>

                <div className="d-flex gap-2">
                  <Button onClick={handleReset}>Reset</Button>
                  <Button onClick={() => handleSubmitSetting(true)}>
                    Restore
                  </Button>
                  <Button
                    onClick={() => handleSubmitSetting(null, false)}
                    color="success"
                  >
                    Save & View
                  </Button>
                </div>
              </div>
              <Row>
                <Col>
                  <label htmlFor="">Theme</label>
                  <select
                    name="theme"
                    id="font-weight"
                    className="form-select"
                    value={theme}
                    onChange={(e) => handleTheme(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value={1}>Theme 1</option>
                  </select>
                </Col>
              </Row>
              {!imgShow && (
                <div>
                  <Button
                    onClick={() => setImgShow(true)}
                    color="primary"
                    className="mt-2"
                  >
                    Show Theme Image
                  </Button>
                </div>
              )}
              {imgShow && (
                <ThemeImageShow
                  themeImg={themeImg[theme]}
                  handleClose={handleClose}
                />
              )}
              {+theme === ThemeNo.ThemeOne && (
                <LatestNewThemeOne
                  imageUpload={imageUpload}
                  handleSubmitSetting={handleSubmitSetting}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SettingImageParentPopup;
